import { EsrType, EstateTypeId, SortCriteria } from '../../ts/service/realEstateService.enum'

export enum SearchBoxDefault {
    PAGE = 1,
    PAGE_SIZE = 20,
    TOTAL_COUNT = 0,
    SEARCH_RADIUS = '20',
    SELECTED_SORT = SortCriteria.DISTANCE,
    ETYPE = EstateTypeId.APARTMENT,
    ESR = EsrType.RENT,
}
